import type { PermanentBuildingKind } from '../entities/Building.js';
import type { EntityId, PlayerId, Tick } from '../ids.js';

import type { CommandBase } from './Command.js';

// BuildCommand only constructs player-buildable kinds (production_hub, turret).
// mini_turret is created via Engineer's Q ability and cannot be issued through
// BuildCommand — narrowing the type here makes the contract explicit.
export interface BuildCommand extends CommandBase {
  kind: 'build';
  coreId: EntityId;
  slotIndex: number;
  building: PermanentBuildingKind;
}

export function makeBuildCommand(args: {
  issuedBy: PlayerId;
  tick: Tick;
  coreId: EntityId;
  slotIndex: number;
  building: PermanentBuildingKind;
}): BuildCommand {
  return {
    kind: 'build',
    issuedBy: args.issuedBy,
    tick: args.tick,
    coreId: args.coreId,
    slotIndex: args.slotIndex,
    building: args.building,
  };
}
